import React from 'react';
import { observer } from 'mobx-react';

import { classes } from '~utils/ClassNames';
import getLanguage from '~utils/getLanguage';
import { useDrupalNodes } from '~api/DrupalAPI/hooks/useDrupalNodes';

interface IDrupalNode {
    nodeIds: string[];
    className?: string;
}

const drupalNodeClass = classes('drupal-node');

export const DrupalNodeComponent = observer((props: IDrupalNode) => {
    const language = getLanguage();
    const { nodeHTML, isValidNodeId } = useDrupalNodes(props.nodeIds, language);

    return !!nodeHTML && isValidNodeId ? (
        <div className={drupalNodeClass}>
            <div className={props.className} dangerouslySetInnerHTML={{ __html: nodeHTML }} />
        </div>
    ) : null;
});
